import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { graphql, useStaticQuery } from 'gatsby';
import { CookieConsentQuery } from '../../types/graphql-types';
import { useTransformNode } from '../hooks/useTransformer';
import renderHtml from '../lib/renderHtml';

const COOKIE_CONSENT_QUERY = graphql`
  query CookieConsent {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "cookie" } } }
    ) {
      edges {
        node {
          id
          fields {
            language
            country
          }
          frontmatter {
            templateKey
            buttonText
            contentText
            privacyPolicy {
              text
              path
            }
          }
        }
      }
    }
  }
`;

const Cookie: React.FC = () => {
  const data = useStaticQuery<CookieConsentQuery>(COOKIE_CONSENT_QUERY);
  const { frontmatter } = useTransformNode(data);

  // TODO: Replace {{privacyPolicy}} with link
  const contentData =
    frontmatter?.contentText?.replace(
      /{{privacyPolicy}}/g,
      `<a href="${frontmatter?.privacyPolicy?.path}" style="color: #28bafd">${frontmatter?.privacyPolicy?.text}</a>`,
    ) ?? '';

  return (
    <CookieConsent
      cookieName="cookie_consent"
      extraCookieOptions={{ domain: process.env.GATSBY_COOKIE_DOMAIN }}
      buttonText={frontmatter?.buttonText}
      buttonStyle={{
        backgroundColor: '#fff',
        borderRadius: '3px',
        color: '#000',
        fontSize: '14.5px',
        fontStyle: 'normal',
        fontWeight: 400,
        margin: '15px 20px',
        padding: '8px 20px',
      }}
      contentStyle={{
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 200,
        margin: '15px 20px',
      }}
      debug={process.env.NODE_ENV === 'development' ? true : false}
      style={{
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        justifyContent: 'center',
      }}
    >
      {renderHtml(contentData)}
    </CookieConsent>
  );
};

export default Cookie;
